export default "__VITE_ASSET__CYY4CZ9O__"